import { t } from 'ttag'
import * as R from 'ramda'
import { TAB_NAMES } from 'components/pages/Jobs/model'

import {
  DownloadCloudIcon,
  Trash2Icon,
  ArchiveIcon,
} from 'components/shared/Icon/Icon'

export const ACTION_DELETE = 'ACTION_DELETE'
export const ACTION_EXPORT = 'ACTION_EXPORT'
export const ACTION_ARCHIVE = 'ACTION_ARCHIVE'

export const getColumns = () => [
  { header: t`position`, accessorKey: 'name', alignLeft: true },
  { header: t`department`, accessorKey: 'department' },
  { header: t`no. of open\npositions`, accessorKey: 'positions' },
  { header: t`candidates`, accessorKey: 'candidates_count' },
  { header: t`started on`, accessorKey: 'start_date' },
  { header: t`updated on`, accessorKey: 'updated' },
  { header: t`status`, accessorKey: 'selection_stage' },
]

export const getActions = ({ count, filter }) => {
  const entity = count !== 1 ? t`jobs` : t`job`

  return [
    {
      icon: DownloadCloudIcon,
      label: t`Export`,
      note: count
        ? t`Export ${count} selected ${entity} to spreadsheet`
        : t`No ${entity} selected for export`,
      type: ACTION_EXPORT,
    },
    {
      icon: ArchiveIcon,
      label: filter.archived ? t`Unarchive` : t`Archive`,
      note: count
        ? filter.archived
          ? t`Unarchive ${count} selected ${entity}`
          : t`Archive ${count} selected ${entity}`
        : t`No ${entity} selected for archivation`,
      type: ACTION_ARCHIVE,
    },
    {
      icon: Trash2Icon,
      label: t`Delete`,
      note: count
        ? t`Delete ${count} selected ${entity}`
        : t`No ${entity} selected for deletion`,
      type: ACTION_DELETE,
    },
  ]
}

export const getFiltersConfigs = keys =>
  R.filter(conf => !keys || R.includes(conf.key, keys), [
    {
      key: 'archived',
      label: t`Show archived jobs`,
      defaultValue: false,
      toggleValue: bool => !bool,
      getQuery: filter => (filter.archived ? { active: false } : {}),
    },
    {
      key: 'department',
      defaultValue: [],
      getQuery: filter => ({
        department: filter.department,
      }),
    },
  ])

export const getTab = state => {
  const { selection_stage } = state

  const tabs = {
    1: TAB_NAMES.DETAILS,
    2: TAB_NAMES.OVERVIEW,
    3: TAB_NAMES.INVITES,
    4: TAB_NAMES.TESTS,
    5: TAB_NAMES.INTERVIEWS,
    6: TAB_NAMES.RESULTS,
  }

  return tabs[selection_stage]
}
